import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import Heading from '@wix/da-shared-react/pkg/a11y/headings/Heading';
import Button from '@wix/da-shared-react/pkg/Button';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import s from './NoDeviantsWatchedEmptyResult.scss';

export interface Props {}

const NoDeviantsWatchedEmptyResult: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <div className={s['root']}>
      <Heading className={s['title']}>
        {t('deviantsYouWatchPage.emptyState.title')}
      </Heading>
      <p className={s['subtitle']}>
        {t('deviantsYouWatchPage.emptyState.subtitle')}
      </p>
      <Button
        className={s['link']}
        view="b16-undisciplined-designers"
        href={Url.browseHomeLink()}
        biData={{
          evid: BiEventType.DEFAULT,
          click_info: 'noDeviantsWatchedEmptyResult.link',
        }}
      >
        {t('deviantsYouWatchPage.emptyState.link')}
      </Button>
    </div>
  );
};
NoDeviantsWatchedEmptyResult.displayName = 'NoDeviantsWatchedEmptyResult';

export default NoDeviantsWatchedEmptyResult;
